/**
 * プラン当日の営業時間
 *
 * 定休日だけ目立たせ、営業している日は控えめに出す。
 * Google の定期営業時間しか持たないため、臨時休業や特別営業日は反映されない。
 */

import { CalendarOff, Clock3 } from 'lucide-react'

import type { PlanDayHours } from '@/api/types/route-plan'
import { cn } from '@/lib/utils'

import { dayHoursLabel } from '../../lib'

type Props = {
  dayHours: PlanDayHours | null
  className?: string
}

export const PlanDayHoursChip = ({ dayHours, className }: Props) => {
  const label = dayHoursLabel(dayHours)
  if (label === null) return null

  const isClosed = dayHours?.closed === true
  return (
    <span
      className={cn(
        'flex shrink-0 items-center gap-1 text-xs',
        isClosed ? 'font-medium text-destructive' : 'tabular-nums text-muted-foreground',
        className,
      )}
    >
      {isClosed ? <CalendarOff size={11} /> : <Clock3 size={11} />}
      {label}
    </span>
  )
}
